module.exports = __webpack_public_path__ + "static/media/agenda-cancel.e5882f05.svg";